import { ComponentProps } from 'react';
import classNames from 'classnames';

import { asianViewIcons, betslipBranding } from 'constants/branding';

import styles from './CashOutIcon.module.scss';

interface CashOutIconProps extends ComponentProps<'i'> {
  isAsianView?: boolean;
  isMatchedBet?: boolean;
  disabled?: boolean;
  title?: string;
  className?: string;
}

const CashOutIcon = ({ title, disabled, isAsianView, isMatchedBet, className, ...props }: CashOutIconProps) => {
  return (
    <span
      className={classNames('fa2 fa2-cash-out-bg', styles.bgIcon, betslipBranding.CASH_OUT_BG_ICON, className, {
        [styles.bgIcon__disabled]: disabled,
        [asianViewIcons.CASH_OUT_BG_ICON]: isAsianView,
        [asianViewIcons.ENABLED]: isAsianView && !disabled,
        [betslipBranding.CASH_OUT_MATCHED_BET_ICON]: isMatchedBet
      })}
      title={title}
      {...props}
    >
      <i
        className={classNames('fa2 fa2-cash-out', styles.icon, betslipBranding.CASH_OUT_ICON, {
          [styles.icon__disabled]: disabled,
          [asianViewIcons.CASH_OUT_ICON]: isAsianView,
          [asianViewIcons.ENABLED]: isAsianView && !disabled,
          [betslipBranding.CASH_OUT_MATCHED_BET_ICON]: isMatchedBet
        })}
      />
    </span>
  );
};

export default CashOutIcon;
